import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { PublicLayout } from './layouts/PublicLayout';
import { Home } from './pages/Home';
import { CheckIn } from './pages/CheckIn';
import { About } from './pages/About';
import { Location } from './pages/Location';
import { Book } from './pages/Book';
import { Spinner } from './components/Primitives';

// Kiosk/Staff/Admin/Status are separate audiences from the marketing site — lazy
// loading them keeps the check-in critical path (spec §46) from paying for code it
// doesn't use.
const Status = lazy(() => import('./pages/Status').then((m) => ({ default: m.Status })));
const Kiosk = lazy(() => import('./pages/Kiosk').then((m) => ({ default: m.Kiosk })));
const Staff = lazy(() => import('./pages/Staff').then((m) => ({ default: m.Staff })));
const Admin = lazy(() => import('./pages/Admin').then((m) => ({ default: m.Admin })));
const NotFound = lazy(() => import('./pages/NotFound').then((m) => ({ default: m.NotFound })));

function PageFallback() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center text-primary">
      <Spinner className="h-8 w-8" />
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/check-in" element={<CheckIn />} />
          <Route path="/about" element={<About />} />
          <Route path="/location" element={<Location />} />
          <Route path="/book" element={<Book />} />
        </Route>
        <Route path="/status/:token" element={<Status />} />
        <Route path="/kiosk" element={<Kiosk />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
